/**
 * Central Axios Instance
 * All API calls must use this instance
 */

import axios from "axios";

/* Axios instance */
const api = axios.create({
  baseURL: "https://aaeternitas.com",
  timeout: 30000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});


/* RESPONSE INTERCEPTOR */
api.interceptors.response.use(

  (response) => {
    return response;
  },

  (error) => {

    if (error.response?.status === 401) {
      // window.dispatchEvent(new Event("openLogin"));
    }

    if (error.response?.status === 403) {
      console.error("Forbidden: Access denied");
    }

    if (error.response?.status >= 500) {
      console.error("Server Error:", error.response?.data?.message);
    }

    return Promise.reject(error);

  }
);



export const getLoggedInUser = async () => {
  try {
    const res = await api.get("/auth/me");
    return res.data.data;
  } catch {
    return null;
  }
};

export default api;